export default function loadScript (src, async = true) {
  const script = document.createElement('script')
  script.src = src
  if (async) script.async = true
  document.head.appendChild(script)
}
